<script lang="ts">
	import { initHeroHomeSwiper } from '$lib/js/script';
	import { onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';

	const lang = $page.params.locale;

	const currentYear = new Date().getFullYear();

	export let award;

	onMount(() => {
		initHeroHomeSwiper();
	});
</script>

<footer>
	<div class="container-fluid py-md-5 pt-5 pb-3 px-md-0 px-3">
		<div class="container">
			<div class="row g-0">
				<div class="col-md-6 col-12 row g-0 pe-md-3 order-md-1 order-2 mb-md-0 mb-3">
					<div class="col-md-8 display-4 ff-lola-bir main-color mb-0">{@html $_('footer_title')}</div>
				</div>
				<div
					class="col-md-6 col-12 row g-0 justify-content-center justify-content-md-start ps-md-3 order-md-2 order-1 mb-md-0 mb-5"
				>
					<div class="col-md-4 col-6 order-md-1 order-1 pe-md-3 mb-md-0 mb-3">
						<p class="ff-lola-bir main-color fs-5 mb-md-4 mb-2">{$_('footer_sub_1')}</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://www.ihg.com/hotels/us/en/global/about"
								target="_blank"
								class="main-color text-decoration-none"><small>{$_('footer_link_1')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://www.ihg.com/hotels/us/en/global/about"
								target="_blank"
								class="main-color text-decoration-none"><small>{$_('footer_link_2')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://www.ihg.com/hotels/us/en/global/about/brands"
								target="_blank"
								class="main-color text-decoration-none"><small>{$_('footer_link_3')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://www.ihg.com/hotels/us/en/global/about/brands"
								target="_blank"
								class="main-color text-decoration-none"><small>{$_('footer_link_4')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://wa.me/6281139602069"
								target="_blank"
								class="main-color text-decoration-none"><small>{$_('footer_link_5')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
							data-sveltekit-reload href="/{lang}/faq"
								class="main-color text-decoration-none"><small>{$_('footer_link_6')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
							data-sveltekit-reload href="/{lang}/press-release"
								class="main-color text-decoration-none"><small>{$_('footer_link_7')}</small></a
							>
						</p>
					</div>
					<div class="col-md-4 col-6 order-2 order-md-2 pe-md-3 mb-md-0 mb-3">
						<p class="ff-lola-bir main-color fs-5 mb-md-4 mb-2">{$_('footer_sub_2')}</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://www.ihg.com/content/us/en/customer-care/privacy-and-cookie-center"
								target="_blank"
								class="main-color text-decoration-none"><small>{$_('footer_link_8')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://www.ihg.com/hotels/us/en/customer-care/forms/privacy?hideBack=true&option=doNotSell"
								target="_blank"
								class="main-color text-decoration-none"
								><small>{$_('footer_link_9')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a
								href="https://www.ihg.com/holidayinnresorts/content/us/en/support/site-map"
								target="_blank"
								class="main-color text-decoration-none"><small>{$_('footer_link_10')}</small></a
							>
						</p>
						<p class="mb-md-1 mb-0 ff-helvetica">
							<a href="/" class="main-color text-decoration-none"><small>{$_('footer_link_11')}</small></a>
						</p>
						<p class="mb-1 ff-helvetica">
							<a href="/" class="main-color text-decoration-none"><small>{$_('footer_link_12')}</small></a>
						</p>
						<p class="mb-1 ff-helvetica">
							<a href="/" class="main-color text-decoration-none"><small>{$_('footer_link_13')}</small></a
							>
						</p>
					</div>
					<div
						class="col-md-3 col-7 order-4 order-md-3 px-md-2 px-2 mb-md-0 mb-3 align-self-start"
						id="container-slider-award"
					>
						<p class="ff-lola-bir main-color fs-5 mb-md-4 mb-2 text-center">{$_('footer_sub_3')}</p>
						<div class="swiper slider-award px-md-0 px-2 position-relative">
							<div class="swiper-wrapper">
								{#each award.featured_images as img}
									<div class="swiper-slide px-4">
										<div class="ratio ratio-1x1">
											<img
												alt="Holiday Inn Resorts Nusa Dua"
												src={img.path}
												class="lazy w-100 h-100 object-fit-cover"
											/>
										</div>
									</div>
								{/each}
							</div>

							<div
								class="nav-slider-award position-absolute top-50 start-0 translate-middle-y w-100 d-flex justify-content-between z-3"
							>
								<span  class="text-decoration-none btn-next fs-4 main-color d-flex pb-3"
									><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 26" fill="none">
										<path d="M14 25L2 13L14 0.999999" stroke="#757FBD" stroke-width="2"/>
									  </svg></span
								>
								<span  class="text-decoration-none btn-prev fs-4 main-color d-flex pb-3"
									><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 26" fill="none">
										<path d="M1 1L13 13L1 25" stroke="#757FBD" stroke-width="2"/>
									  </svg></span
								>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row g-0 mt-md-5 justify-content-between align-items-center">
				<div class="col-md-6 pe-md-3 mb-md-0 mb-4 row g-0">
					<div class="col-md-12 col-6 pe-3 pe-md-0 mb-md-4 mb-3">
						<img alt="Holiday Inn Resorts Nusa Dua" src="/img/logo.webp" class="logo" />
					</div>

					<p class="ff-lola-bir main-color fs-5 mb-md-4 mb-3">Holiday Inn Resort Bali Nusa Dua</p>
					<p class="mb-1 ff-helvetica">
						<a
							id="call_inter"
							href="tel:03618947888"
							target="_blank"
							class="main-color text-decoration-none"
							><i class="ri-phone-line me-1 align-middle"></i><small
								>Front desk : +62 361 894 7888</small
							></a
						>
					</p>
					<p class="mb-1 ff-helvetica">
						<a
							id="mail"
							href="mailto:reservation.nusadua@ihg.com"
							target="_blank"
							class="main-color text-decoration-none"
							><i class="ri-mail-line me-1 align-middle"></i><small
								>reservation.nusadua@ihg.com</small
							></a
						>
					</p>
					<p class="mb-1 ff-helvetica">
						<a
							href="https://maps.app.goo.gl/wwen7Rh1azvarTxy9"
							target="_blank"
							class="main-color text-decoration-none"
							><i class="ri-map-pin-line me-1 align-middle"></i><small
								>Jl. Pratama No.86, Tanjung, Benoa, Kec. Kuta Sel., Kabupaten Badung, Bali 80363</small
							></a
						>
					</p>
					<p class="fs-2 mb-md-0 mb-4">
						<a
							href="https://www.instagram.com/holidayinnbalinusadua/"
							target="_blank"
							class="main-color text-decoration-none"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="35"
								height="35"
								viewBox="0 0 48 49"
								fill="none"
							>
								<path
									d="M24 15.6348C22.2941 15.6348 20.6266 16.1406 19.2082 17.0883C17.7898 18.0361 16.6843 19.3831 16.0315 20.9591C15.3787 22.5351 15.2079 24.2693 15.5407 25.9424C15.8735 27.6155 16.695 29.1523 17.9012 30.3586C19.1074 31.5648 20.6443 32.3862 22.3173 32.719C23.9904 33.0518 25.7246 32.881 27.3006 32.2282C28.8767 31.5754 30.2237 30.4699 31.1714 29.0516C32.1192 27.6332 32.625 25.9656 32.625 24.2598C32.622 21.9732 31.7124 19.7811 30.0955 18.1643C28.4787 16.5474 26.2866 15.6377 24 15.6348ZM24 30.6348C22.7391 30.6348 21.5066 30.2609 20.4582 29.5604C19.4099 28.8599 18.5928 27.8643 18.1103 26.6994C17.6278 25.5345 17.5015 24.2527 17.7475 23.0161C17.9935 21.7794 18.6006 20.6435 19.4922 19.752C20.3838 18.8604 21.5197 18.2532 22.7563 18.0073C23.9929 17.7613 25.2747 17.8875 26.4396 18.37C27.6045 18.8525 28.6001 19.6696 29.3006 20.718C30.0011 21.7664 30.375 22.9989 30.375 24.2598C30.375 25.9505 29.7034 27.572 28.5078 28.7676C27.3123 29.9631 25.6908 30.6348 24 30.6348ZM33 5.13477H15C12.3156 5.13774 9.74199 6.20544 7.84383 8.1036C5.94567 10.0018 4.87798 12.5754 4.875 15.2598V33.2598C4.87798 35.9442 5.94567 38.5178 7.84383 40.4159C9.74199 42.3141 12.3156 43.3818 15 43.3848H33C35.6844 43.3818 38.258 42.3141 40.1562 40.4159C42.0543 38.5178 43.122 35.9442 43.125 33.2598V15.2598C43.122 12.5754 42.0543 10.0018 40.1562 8.1036C38.258 6.20544 35.6844 5.13774 33 5.13477ZM40.875 33.2598C40.875 35.3483 40.0453 37.3514 38.5685 38.8282C37.0916 40.3051 35.0886 41.1348 33 41.1348H15C12.9114 41.1348 10.9084 40.3051 9.43153 38.8282C7.95468 37.3514 7.125 35.3483 7.125 33.2598V15.2598C7.125 13.1712 7.95468 11.1681 9.43153 9.6913C10.9084 8.21445 12.9114 7.38477 15 7.38477H33C35.0886 7.38477 37.0916 8.21445 38.5685 9.6913C40.0453 11.1681 40.875 13.1712 40.875 15.2598V33.2598ZM35.625 14.5098C35.625 14.8806 35.515 15.2431 35.309 15.5515C35.103 15.8598 34.8101 16.1001 34.4675 16.242C34.1249 16.384 33.7479 16.4211 33.3842 16.3487C33.0205 16.2764 32.6864 16.0978 32.4242 15.8356C32.1619 15.5734 31.9834 15.2393 31.911 14.8756C31.8387 14.5118 31.8758 14.1348 32.0177 13.7922C32.1596 13.4496 32.4 13.1568 32.7083 12.9508C33.0166 12.7447 33.3792 12.6348 33.75 12.6348C34.2473 12.6348 34.7242 12.8323 35.0758 13.1839C35.4275 13.5356 35.625 14.0125 35.625 14.5098Z"
									fill="#757FBD"
								/>
							</svg></a
						>
						<a
							href="https://www.facebook.com/holidayinnbali"
							target="_blank"
							class="main-color text-decoration-none"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="35"
								height="35"
								viewBox="0 0 48 49"
								fill="none"
							>
								<path
									d="M24 5.13477C20.2174 5.13477 16.5198 6.25643 13.3747 8.35791C10.2296 10.4594 7.77834 13.4463 6.33081 16.9409C4.88329 20.4356 4.50455 24.281 5.24249 27.9909C5.98043 31.7008 7.80191 35.1085 10.4766 37.7832C13.1513 40.4579 16.559 42.2793 20.2689 43.0173C23.9788 43.7552 27.8242 43.3765 31.3188 41.929C34.8135 40.4814 37.8004 38.0301 39.9019 34.885C42.0033 31.74 43.125 28.0423 43.125 24.2598C43.1191 19.1893 41.1022 14.3283 37.5168 10.7429C33.9315 7.15758 29.0704 5.14072 24 5.13477ZM25.125 41.0973V28.3848H30C30.2984 28.3848 30.5845 28.2662 30.7955 28.0553C31.0065 27.8443 31.125 27.5581 31.125 27.2598C31.125 26.9614 31.0065 26.6752 30.7955 26.4643C30.5845 26.2533 30.2984 26.1348 30 26.1348H25.125V21.2598C25.125 20.3647 25.4806 19.5062 26.1135 18.8733C26.7465 18.2403 27.6049 17.8848 28.5 17.8848H31.5C31.7984 17.8848 32.0845 17.7662 32.2955 17.5553C32.5065 17.3443 32.625 17.0581 32.625 16.7598C32.625 16.4614 32.5065 16.1752 32.2955 15.9643C32.0845 15.7533 31.7984 15.6348 31.5 15.6348H28.5C27.0082 15.6348 25.5774 16.2274 24.5225 17.2823C23.4676 18.3372 22.875 19.7679 22.875 21.2598V26.1348H18C17.7016 26.1348 17.4155 26.2533 17.2045 26.4643C16.9935 26.6752 16.875 26.9614 16.875 27.2598C16.875 27.5581 16.9935 27.8443 17.2045 28.0553C17.4155 28.2662 17.7016 28.3848 18 28.3848H22.875V41.0973C18.5067 40.8054 14.4228 38.8272 11.4857 35.5805C8.54865 32.3338 6.98838 28.0726 7.1344 23.697C7.28041 19.3214 9.12128 15.1737 12.2683 12.13C15.4152 9.08632 19.6219 7.38481 24 7.38481C28.3781 7.38481 32.5848 9.08632 35.7318 12.13C38.8787 15.1737 40.7196 19.3214 40.8656 23.697C41.0116 28.0726 39.4514 32.3338 36.5143 35.5805C33.5773 38.8272 29.4933 40.8054 25.125 41.0973Z"
									fill="#757FBD"
								/>
							</svg></a
						>
						<a
							href="https://www.youtube.com/channel/UCAID2tIZzpFiHfNujh4TSww"
							target="_blank"
							class="main-color text-decoration-none"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="35"
								height="35"
								viewBox="0 0 48 49"
								fill="none"
							>
								<path
									d="M30.6244 23.3223L21.6244 17.3223C21.4548 17.2092 21.2578 17.1443 21.0542 17.1344C20.8506 17.1246 20.6482 17.1703 20.4686 17.2665C20.289 17.3628 20.1389 17.5061 20.0343 17.681C19.9298 17.8559 19.8747 18.056 19.875 18.2598V30.2598C19.8747 30.4636 19.9298 30.6637 20.0343 30.8386C20.1389 31.0135 20.289 31.1568 20.4686 31.2531C20.6482 31.3493 20.8506 31.395 21.0542 31.3852C21.2578 31.3753 21.4548 31.3104 21.6244 31.1973L30.6244 25.1973C30.7791 25.0947 30.906 24.9554 30.9938 24.7918C31.0816 24.6282 31.1275 24.4455 31.1275 24.2598C31.1275 24.0742 31.0816 23.8914 30.9938 23.7278C30.906 23.5642 30.7791 23.4249 30.6244 23.3223ZM22.125 28.1579V20.3617L27.9712 24.2598L22.125 28.1579ZM43.575 13.3848C43.4122 12.7524 43.1016 12.1676 42.6687 11.6787C42.2358 11.1897 41.693 10.8105 41.085 10.5723C34.6875 8.09543 24.4256 8.1348 24 8.1348C23.5744 8.1348 13.3125 8.09543 6.9075 10.5723C6.30086 10.8115 5.75957 11.1911 5.32803 11.68C4.8965 12.1689 4.58703 12.7532 4.425 13.3848C3.94688 15.2392 3.375 18.6348 3.375 24.2598C3.375 29.8848 3.94688 33.2804 4.425 35.1348C4.58778 35.7672 4.89839 36.352 5.33128 36.8409C5.76417 37.3299 6.30696 37.7091 6.915 37.9473C13.3125 40.4242 23.5725 40.3848 24 40.3848H24.1331C25.4288 40.3848 35.0081 40.3023 41.0925 37.9473C41.7005 37.7091 42.2433 37.3299 42.6762 36.8409C43.1091 36.352 43.4197 35.7672 43.5825 35.1348C44.0606 33.2842 44.6325 29.8979 44.6325 24.2598C44.6325 18.6217 44.0625 15.2392 43.575 13.3848ZM41.3962 34.5723C41.324 34.8605 41.1844 35.1274 40.9888 35.351C40.7932 35.5747 40.5473 35.7486 40.2712 35.8586C34.2712 38.1704 24.1087 38.1348 24 38.1348C23.8913 38.1348 13.7419 38.1723 7.73438 35.8529C7.45836 35.743 7.21242 35.569 7.01683 35.3454C6.82123 35.1218 6.68158 34.8549 6.60938 34.5667C6.1575 32.8436 5.625 29.6561 5.625 24.2598C5.625 18.8636 6.1575 15.6761 6.60375 13.9473C6.67595 13.6591 6.81561 13.3922 7.0112 13.1686C7.2068 12.9449 7.45274 12.771 7.72875 12.6611C13.5113 10.4336 23.1619 10.3848 23.955 10.3848H24C24.1012 10.3848 34.2581 10.3473 40.2656 12.6667C40.5416 12.7766 40.7876 12.9506 40.9832 13.1742C41.1788 13.3978 41.3184 13.6647 41.3906 13.9529C41.8369 15.6761 42.3694 18.8636 42.3694 24.2654C42.3694 29.6673 41.8425 32.8436 41.3962 34.5723Z"
									fill="#757FBD"
								/>
							</svg></a
						>
					</p>
				</div>
				<div class="col-md-6 ps-md-3">
					<div class="col-md-12 col-6 ps-md-0 mb-3 row g-0">
						<a
							href="https://www.ihg.com/hotels/id/in/find-hotels/interstitial?forwardUrl=http%3A%2F%2Fgo.onelink.me%2Fihg%3Fpid%3Dglobal_desktop%26c%3Dglobal_desktop_id_in_footer%26af_web_dp%3Dhttp%3A%2F%2Fwww.ihg.com%2Fhotels%2Fid%2Fin%2Fglobal%2Foffers%2Fmobile%26cm_sp%3DOSMGL-US-EN-MAN-Footer-AppDownload&srcUrl=https%3A%2F%2Fwww.ihg.com%2Fholidayinnresorts%2Fhotels%2Fid%2Fin%2Fbali%2Fdpsba%2Fhoteldetail%2Fdining&type=gdpr"
							target="_blank"
							class="col-md-2 col-5 me-2 me-md-3 mb-md-0 mb-2"
						>
							<img
								alt="Holiday Inn Resorts Nusa Dua"
								src="/img/app-store.png"
								class="lazy img-fluid"
							/>
						</a>
						<a
							href="https://www.ihg.com/hotels/id/in/find-hotels/interstitial?forwardUrl=http%3A%2F%2Fgo.onelink.me%2Fihg%3Fpid%3Dglobal_desktop%26c%3Dglobal_desktop_id_in_footer%26af_web_dp%3Dhttp%3A%2F%2Fwww.ihg.com%2Fhotels%2Fid%2Fin%2Fglobal%2Foffers%2Fmobile%26cm_sp%3DOSMGL-id-in-MAN-Footer-AppDownload&srcUrl=https%3A%2F%2Fwww.ihg.com%2Fholidayinnresorts%2Fhotels%2Fid%2Fin%2Fbali%2Fdpsba%2Fhoteldetail%2Fdining&type=gdpr"
							target="_blank"
							class="col-md-2 col-5 me-2 me-md-3 mb-md-0 mb-2"
						>
							<img
								alt="Holiday Inn Resorts Nusa Dua"
								src="/img/google-play.png"
								class="lazy img-fluid"
							/>
						</a>
						<div class="col-md-2 me-3 d-none d-md-block">
							<img
								alt="Holiday Inn Resorts Nusa Dua"
								src="/img/best-price.png"
								class="lazy img-fluid"
							/>
						</div>
						<div class="col-md-2 me-3 d-none d-md-block">
							<img
								alt="Holiday Inn Resorts Nusa Dua"
								src="/img/book-online.png"
								class="lazy img-fluid"
							/>
						</div>
						<div class="col-12 d-block d-md-none">
							<p class="ff-helvetica">
								<small
									>{$_('footer_desc_app')}</small
								>
							</p>
						</div>
					</div>
					<div class="col-md-12 row g-0 d-none d-md-block">
						<div class="col-md-5">
							<p class="ff-helvetica">
								<small
									>{$_('footer_desc_app')}</small
								>
							</p>
						</div>
					</div>

					<!-- <div class="row g-0 d-flex d-md-none mb-5">
						<div class="col-4 me-3">
							<img
								alt="Holiday Inn Resorts Nusa Dua"
								src="/img/best-price.png"
								class="lazy img-fluid"
							/>
						</div>
						<div class="col-4 me-3">
							<img
								alt="Holiday Inn Resorts Nusa Dua"
								src="/img/book-online.png"
								class="lazy img-fluid"
							/>
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
	<div class="container-fluid p-0 text-center py-2 main-bg text-white copyright-section">
		<p class="mb-0">
			<small
				>© {currentYear} IHG. All rights reserved. Most hotels are independently owned and operated.</small
			>
		</p>
	</div>
</footer>

<style>
	footer .logo {
		width: 150px;
	}
	.nav-slider-award .btn-prev, .nav-slider-award .btn-next{
		cursor: pointer;
	}
	@media (max-width: 600px) {
		footer .logo {
			width: 130px;
		}
		.copyright-section{
			padding-bottom: 7rem!important;
		}
	}
</style>
